export default [
  {
    path: '/bookmarks',
    name: 'bookmarks#index',
    component: () => import('@views/bookmarks/index'),
    meta: {
      header: false,
    },
  },
  {
    path: '/bookmarks/:bookmarkId',
    name: 'bookmarks#show',
    component: () => import('@views/bookmarks/show'),
    meta: {
      header: true,
    },
  },
];
